"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Activity, ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ActivateYourDataStack() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223796" id="prêt-à-expédier-ready-to-ship" className="relative flex min-h-[70vh] items-center justify-center overflow-hidden dark bg-gradient-to-br from-[#0A1F44] to-[#1E4D92] text-foreground py-24 sm:py-32">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,var(--color-primary)_0%,transparent_70%)] opacity-10"></div>

      {}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none overflow-hidden">
        <div className="absolute size-[200px] sm:size-[300px] rounded-full border border-primary/40 animate-ping [animation-duration:4s]"></div>
        <div className="absolute size-[300px] sm:size-[450px] rounded-full border border-primary/30 animate-ping [animation-duration:4s] [animation-delay:1s]"></div>
        <div className="absolute size-[400px] sm:size-[600px] rounded-full border border-primary/20 animate-ping [animation-duration:4s] [animation-delay:2s]"></div>
        <div className="absolute size-[500px] sm:size-[750px] rounded-full border border-primary/10 animate-ping [animation-duration:4s] [animation-delay:3s]"></div>
      </div>

      {}
      <div ref={ref} className={`relative z-10 container mx-auto px-4 text-center transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="inline-flex items-center justify-center p-4 mb-8 rounded-full bg-primary/20 text-primary ring-1 ring-primary/40 backdrop-blur-sm shadow-lg shadow-primary/30">
          <Activity className="size-8" />
        </div>

        <h2 className="font-default text-5xl sm:text-6xl md:text-8xl font-bold tracking-tighter mb-6 text-white">
          Prêt à{" "}
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-secondary">
            Expédier ?
          </span>
        </h2>

        <p className="max-w-2xl mx-auto text-lg sm:text-xl text-slate-200 mb-10 font-default leading-relaxed">
          Optimisez vos flux internationaux avec Sahel Forwarding Services. De Dakar vers le monde entier, nous assurons une logistique fluide, sécurisée et performante pour votre entreprise.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6">
          <Button size="lg" className="w-full sm:w-auto group text-base h-12 px-8 bg-primary text-primary-foreground hover:bg-primary/90 shadow-xl shadow-primary/20" asChild>
            
          </Button>
          <Button size="lg" variant="outline" className="w-full sm:w-auto text-base h-12 px-8 border-white/30 text-white hover:bg-white/10 hover:text-white transition-colors backdrop-blur-sm" asChild>
            <Link to="#">
              Nous Contacter
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}